var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-tippy',{attrs:{"content":_vm.content,"placement":"left"},nativeOn:{"click":function($event){return _vm.$emit('go-to')}}},[_c('base-button-icon',{attrs:{"color-type":"secondary","icon":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }